export enum VALIDATION_TYPES {
  GENERAL = "GENERAL",
  NUMBERS = "NUMBERS",
  CHECKED = "CHECKED",
  EMAIL = "EMAIL",
  EMAIL_NOT_CONFIRMED = "EMAIL_NOT_CONFIRMED",
  FIELDS_NOT_MATCH = "FIELDS_NOT_MATCH",
  FUTURE_DATE_REQUIRED = "FUTURE_DATE_REQUIRED",
  ONE_OF_TWO = "ONE_OF_TWO",
  REQUIRED = "REQUIRED",
  NOT_UNIQUE = "NOT_UNIQUE",
  MORE_THAN = "MORE_THAN",
  ARRAY_MORE_THAN = "ARRAY_MORE_THAN",
  MAX_LENGTH = "MAX_LENGTH",
  MIN_LENGTH = "MIN_LENGTH",
  BAD_CONTENT_TYPE = "BAD_CONTENT_TYPE",
  TOKEN_EXPIRED = "TOKEN_EXPIRED",
  TOKEN_USED = "TOKEN_USED",
  TOKEN_NOT_FOUND = "TOKEN_NOT_FOUND",
  TOO_BIG_NUMBER = "TOO_BIG_NUMBER",
  ALREADY_EXISTS = "ALREADY_EXISTS",
  MAX_2_DECIMAL_PLACES = "MAX_2_DECIMAL_PLACES",
  UPLOAD_PROGRESS = "UPLOAD_PROGRESS",
  UPLOAD_ERRORS = "UPLOAD_ERRORS",
  NO_DEFAULT_CV = "NO_DEFAULT_CV",
  BANKGIRO = "BANKGIRO",
  PLUSGIRO = "PLUSGIRO",
  IBAN = "IBAN",
  SWIFT = "SWIFT",
  VALID_URL = "VALID_URL",
  PRIMARY = "PRIMARY",
  MULTIPLE_REQUIRED_FIELDS = "MULTIPLE_REQUIRED_FIELDS",
  MULTIPLE_REQUIRED_FIELDS_PL = "MULTIPLE_REQUIRED_FIELDS_PL",
}
